import React, { useState, useEffect, useRef, useContext, useCallback, useMemo } from 'react';
import { connect, useSelector, useDispatch } from 'react-redux';
import { selectViewedRooms, updateShowSendingMessage } from '../../redux/room/room.actions';
import useChat from '../../services/socket';

import { Grid, Table, IconButton, Autocomplete, TextField, Typography, Tooltip, RadioGroup, FormControlLabel, Radio, FormControl, Box, Select, MenuItem, ToggleButton, ToggleButtonGroup } from '@mui/material';
import {
  SearchSharp, ClearAllSharp, KeyboardArrowDownSharp, KeyboardArrowUpSharp, InboxSharp, InboxOutlined, Close
} from '@material-ui/icons';
import './room-list.css';

import { getUser, getUsers, logOut, setCurrentUser } from '../../redux/user/user.actions';
import {
  getInProgressRooms, getAllRooms, setViewedRooms,
} from '../../redux/room/room.actions';
import { getClientById, getClients, setCurrentClient } from '../../redux/client/client.actions';

import Room from '../Room';
import Chat from '../Chat';
import ChatOptions from '../ChatOptions';
import { ThemeContext } from '../../components/ThemeContext/ThemeContext';
import SearchBar from '../SearchBar';
import RoomListTable from '../RoomListTable';
import { CloseFullscreen, Person, Groups, ForumOutlined } from '@mui/icons-material';
import { selectChats, setCurrentChatMessages } from '../../redux/whatsapp/whatsapp.actions';
// A cadeia de filtros desta lista mora fora do componente, pura e num lugar
// so. Antes `displayedRooms` era um ESTADO escrito de seis pontos, dois
// deles filtrando a lista sobre si mesma -- e o que o operador via dependia
// da ordem em que os efeitos rodavam.
import { filtrarConversas } from '../../utils/listaDeConversas';
// O vocabulario do filtro de canal, o mesmo do Painel de Atendimentos.
import { CANAIS, CANAL_TODOS } from '../../utils/canalDaConversa';

const RoomList = props => {
  const [roomId, setRoomId] = useState();
  const [messages, setMessages] = useState([]);
  // Quantas mensagens a sala aberta TEM. Vem da linha da conversa (`Room`)
  // e desce para o `Chat`, que compara com o que esta desenhado para saber
  // se ainda ha historico mais antigo ao rolar ate o topo.
  const [totalDeMensagens, setTotalDeMensagens] = useState(0);
  const [inProgressRooms, setInProgressRooms] = useState([]);
  const [operatorSendMessage, setOperatorSendMessage] = useState();
  const selected = useRef(false);
  const roomRefs = useRef({});
  const user = JSON.parse(localStorage.getItem("user"));

  const [chatClosed, setChatClosed] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [sortOrder, setSortOrder] = useState("asc");
  // A ordenacao APLICADA (null = o operador nao clicou em ordenar, e a
  // ordem e a que a api devolveu). `sortOrder` continua sendo a direcao do
  // PROXIMO clique, que e o que a seta do SearchBar mostra.
  const [ordemAplicada, setOrdemAplicada] = useState(null);
  // O canal dos dados (item 6). Mesmos valores e rotulos do Painel de
  // Atendimentos: o operador nao deve aprender dois nomes para o mesmo
  // filtro.
  const [canal, setCanal] = useState(CANAL_TODOS);
  const [filterUnread, setFilterUnread] = useState(false);
  const inProgressRoomsLength = props.inProgressRooms ? props.inProgressRooms.length : 0;
  const { getClientById, setCurrentClient, setSelectedRoom, getInProgressRooms, getAllRooms } = props;
  const { theme } = useContext(ThemeContext);
  const [selectedRoomRef, setSelectedRoomRef] = useState(null);
  const [filterType, setFilterType] = useState(user?.id);
  const { permissions } = props;

  const [visibleMessages, setVisibleMessages] = useState([]);
  const whatsAppChats = useSelector(selectChats);
  const viewedRooms = useSelector(selectViewedRooms);
  const initialRoomIdApplied = useRef(false);
  const dispatch = useDispatch();

  /**
   * O canal de SAIDA da sala selecionada -- UMA instancia para a lista toda.
   *
   * Antes isto vivia dentro de `Room`, que e uma LINHA da lista: cada linha
   * abria um socket para a sala selecionada e pedia as mensagens dela. Dez
   * conversas na lista eram dez conexoes e dez `GET /messages/{id}` a cada
   * clique, e trocar de sala derrubava as dez para reabrir outras dez.
   *
   * Sem o objeto `room` de proposito -- ver o comentario longo em
   * `components/Room/index.jsx`. E o que mantem `operatorId: user.id`, ou
   * seja, a mensagem atribuida a quem esta escrevendo, e nao ao dono da sala.
   */
  const chatDaSalaSelecionada = useChat(roomId);

  /*
   * A instancia muda de identidade a cada render; o `ref` nao. As duas funcoes
   * abaixo sao estaveis e leem a instancia na hora da chamada, entao passa-las
   * para baixo nao invalida nenhum `useMemo` da lista.
   */
  const chatDaSalaSelecionadaRef = useRef(chatDaSalaSelecionada);
  chatDaSalaSelecionadaRef.current = chatDaSalaSelecionada;

  const enviarNaSalaSelecionada = useCallback(
    (message, usuario, id, type, whatsapp) =>
      chatDaSalaSelecionadaRef.current?.sendMessage(message, usuario, id, type, whatsapp),
    []
  );

  const avisarDigitacaoNaSalaSelecionada = useCallback(
    (evento) => chatDaSalaSelecionadaRef.current?.sendingMessageEvent(evento),
    []
  );

  /*
   * O "digitando" do cliente. Era feito em cada linha da lista, e o efeito
   * rodava a cada render enquanto o sinal estivesse ligado -- empilhando
   * dispatch e `setTimeout` para um unico indicador. O que a tela mostra e
   * quanto tempo mostra nao mudou.
   *
   * ## O que vai para o redux e a SALA, nao um `true`
   *
   * Enquanto era booleano, toda linha da lista lia o mesmo sinal: o cliente
   * de UMA conversa digitava e as conversas de TODO MUNDO trocavam a previa
   * da ultima mensagem por "Cliente esta digitando ....". O operador via a
   * lista inteira piscando e perdia de vista qual conversa tinha novidade.
   *
   * Guardando o `room_id`, cada linha pergunta "e a minha?" -- e a resposta
   * e a mesma informacao de antes, so que atribuida a quem ela pertence.
   *
   * O sinal so pode vir da sala ABERTA: desde a correcao de desempenho ha
   * UMA conexao de socket (`useChat(roomId)`), a da conversa selecionada.
   * Mandar o id nao e, portanto, "preparar para o futuro" -- e dizer a
   * verdade sobre o que o sinal sempre significou.
   */
  const sinalDeDigitacao = chatDaSalaSelecionada?.sendingMessage;
  useEffect(() => {
    if (sinalDeDigitacao !== true || !roomId) return;
    dispatch(updateShowSendingMessage(roomId));
    const relogio = setTimeout(() => dispatch(updateShowSendingMessage(false)), 1500);
    return () => clearTimeout(relogio);
  }, [sinalDeDigitacao, roomId, dispatch]);

  /**
   * A lista que a tela mostra, DERIVADA da fonte do redux.
   *
   * Nenhum passo grava por cima do vizinho, entao os filtros compoem: ligar
   * dois recorta a intersecao, e desligar um devolve a lista. Era isso que
   * faltava -- com o estado acumulador, filtrar sobre o resultado anterior
   * fazia a lista encolher e nunca mais crescer.
   */
  const conversasVisiveis = useMemo(() => filtrarConversas({
    conversas: props.inProgressRooms,
    canal,
    somenteNaoLidas: filterUnread,
    busca: searchValue,
    ordem: ordemAplicada,
  }), [props.inProgressRooms, canal, filterUnread, searchValue, ordemAplicada]);

  /*
   * O Escape fecha a conversa aberta.
   *
   * ISTO DERRUBAVA O APP. O ouvinte era registrado uma vez (`[]`) com a
   * funcao do PRIMEIRO render, e ela carrega para sempre os valores daquele
   * momento -- entre eles `selectedRoomRef`, que nasce `null`. A linha
   * `selectedRoomRef.current = null` virava
   * "Cannot set properties of null" em TODA tecla Escape apertada na tela de
   * chat, desde sempre. Era o aviso de lint `missing dependency: 'onKeyup'`
   * que ninguem leu.
   *
   * O ouvinte agora e um envelope estavel que chama a versao ATUAL da funcao,
   * guardada num ref. Registra uma vez so, como antes, e nenhum valor fica
   * velho.
   */
  const onKeyupRef = useRef();

  useEffect(() => {
    const aoSoltarTecla = (e) => onKeyupRef.current && onKeyupRef.current(e);
    window.addEventListener("keyup", aoSoltarTecla);
    return () => {
      window.removeEventListener("keyup", aoSoltarTecla);
    };
  }, []);

  useEffect(() => {
    if (operatorSendMessage === 'typing' && selectedRoomRef.current && selectedRoomRef.current.sendingMessageEvent) {
      selectedRoomRef.current.sendingMessageEvent(operatorSendMessage);
    }
  }, [operatorSendMessage]);

  useEffect(() => {
    if (roomId && roomRefs.current[roomId]) {
      setSelectedRoomRef(roomRefs.current[roomId]);
    } else {
      setSelectedRoomRef({ current: {} });
    }
  }, [roomId]);

  const onKeyup = (e) => {
    if (props.dimensions.width > 575)
      if (e.key === "Escape") {
        setSelectedRoom((prevEscPressed) => null);
        setRoomId(null);
        /*
         * O `selectedRoomRef.current = null` que ficava aqui SAIU, e isso nao
         * e perda de funcionalidade: ele nunca executou -- era ele mesmo quem
         * estourava, e tudo abaixo dele morria junto.
         *
         * E nao da para simplesmente deixa-lo rodar agora. `selectedRoomRef`
         * nao e um ref apesar do nome: e ESTADO, e quando ha sala aberta ele
         * guarda o proprio `React.createRef()` daquela linha da conversa.
         * Zera-lo arrancaria o `useImperativeHandle` do `Room` -- o caminho
         * por onde o campo de mensagem envia. Fechar a conversa ja e feito
         * pelas duas linhas acima.
         */
        props.setCurrentChatMessages([]);
      }
  };

  // Depois da definicao, nao antes: `const` nao pode ser lido acima da propria
  // linha (zona morta temporal).
  onKeyupRef.current = onKeyup;

  const handleSelectRoom = useCallback(async (client, room) => {
    // Verificar se room e room.room_id existem
    if (!room || !room.room_id) {
      console.error('Room or room.room_id is undefined:', room);
      return;
    }

    // Adiciona room ao QuickAccess (viewedRooms) se não existir
    // Segue a mesma lógica de tickets e páginas
    const currentViewedRooms = Array.isArray(viewedRooms) ? viewedRooms : [];
    const roomExists = currentViewedRooms.some(r => r.room_id === room.room_id);
    
    // Se não existe, verifica limite ANTES de adicionar (mesma lógica de tickets)
    if (!roomExists) {
      // REGRA 2: Se não existe, verifica limite ANTES de adicionar
      const limitReached = localStorage.getItem('quickAccessLimitReached') === 'true';
      if (limitReached) {
        // Não adiciona ao QuickAccess se o limite foi atingido, mas continua para abrir o chat
        // (mesma lógica de tickets - navega mesmo sem adicionar)
      } else {
        // REGRA 3: Se passou na verificação, adiciona normalmente
        const updatedRooms = [...currentViewedRooms, room];
        props.setViewedRooms(updatedRooms);
      }
    }

    if (room.whatsapp) {
      setCurrentClient({ name: room.contact.name, telefone: room.contact.id.user });
      setRoomId(room.room_id);
      // Evita atualizar se já é a mesma room selecionada (previne loops)
      if (props.selectedRoom?.room_id !== room.room_id) {
        setSelectedRoom({ ...room, whatsapp: true });
      }
      props.setCurrentChatMessages([]);
      return;
    }

    // A TELA TROCA PRIMEIRO; o cliente é buscado depois.
    //
    // Antes isto era `await getClientById(...)` e só então trocava a sala, ou
    // seja: abrir e trocar de sala custava o tempo de um `GET /clients/{id}`
    // antes de qualquer resposta visual. Era a lentidão relatada em 12/10/2026
    // -- e o ramo do WhatsApp logo acima nunca esperou, que é por que sala de
    // WhatsApp parecia mais rápida que as outras.
    //
    // Nada deixa de acontecer: o `setCurrentClient` do fetch chega igual, só não
    // bloqueia mais a troca. A ordem entre os dois `setCurrentClient` é
    // preservada -- o do `company_id === null` continua valendo DEPOIS do fetch,
    // sobrescrevendo-o como antes.
    /*
     * O CLIENTE QUE A LISTA JA TEM ENTRA AGORA, e isto nao e enfeite.
     *
     * Trocar de sala sem esperar o `GET /clients/{id}` significa que a ficha
     * do cliente monta ANTES da resposta. Sem esta linha ela montava com o
     * `currentClient` anterior -- e, vindo de outra pagina, com `{}`. Nesse
     * caso o `ChatOptions` cai num ramo que SINTETIZA o cliente a partir de
     * `room.name`, coluna que nao existe em `rooms`: os campos chegam
     * `undefined` e a ficha derrubava a tela com "Cannot read properties of
     * undefined (reading 'length')". Era o que acontecia ao abrir sala pelo
     * acesso rapido ou ao entrar na pagina de chat.
     *
     * O `await` que ficava aqui garantia isso por ACIDENTE. Agora e de
     * proposito, e de quebra a ficha nunca mostra o cliente da conversa
     * anterior por um instante.
     *
     * O estado FINAL nao muda: o fetch sobrescreve com o registro completo, e
     * o `setCurrentClient(client)` do `company_id === null` continua valendo
     * depois dele, exatamente como antes.
     */
    if (client) {
      setCurrentClient(client);
    }

    setRoomId(room.room_id);
    if (props.selectedRoom?.room_id !== room.room_id) {
      setSelectedRoom(room);
    }
    props.setCurrentChatMessages([]);

    getClientById(client.id).then(() => {
      if (client.company_id === null) setCurrentClient(client);
    }).catch(err => console.log(err));
  }, [getClientById, setCurrentClient, setSelectedRoom, props, viewedRooms]);

  useEffect(() => {
    if (!props.initialRoomId || !props.inProgressRooms?.length) return;
    // Guarda o último roomId aplicado (não um booleano), para reabrir ao trocar
    // de aba de chat no quickaccess, sem re-aplicar o mesmo em loop.
    if (initialRoomIdApplied.current === props.initialRoomId) return;
    const room = props.inProgressRooms.find(r => r.room_id === props.initialRoomId);
    if (room?.client) {
      initialRoomIdApplied.current = props.initialRoomId;
      handleSelectRoom(room.client, room);
    }
  }, [props.initialRoomId, props.inProgressRooms, handleSelectRoom]);

  /**
   * Pede a fonte de novo. NAO monta mais a lista exibida -- isso e o
   * `conversasVisiveis`.
   *
   * O `return` no modo 'all' segue como estava, e com ele a lista para de se
   * atualizar nesse modo. E defeito anterior a esta mudanca, deixado de fora
   * de proposito: consertar aqui significaria decidir se o modo 'all' deve
   * voltar a consultar `getAllRooms()` em cada ciclo, e isso e peso de
   * consulta em producao, nao detalhe de refactor.
   */
  const getRooms = useCallback(() => {
    if (!user || filterType === 'all') return;
    getInProgressRooms(user.id);
  }, [user, getInProgressRooms, filterType]);

  useEffect(() => {
    // Verificar se messages é um array antes de usar forEach
    // (o aviso de ticket gerado quando o cliente encerra o chat é tratado de forma
    // global, via evento de socket ROOM_CLOSED_BY_CLIENT, em WebSocketContext.js —
    // assim funciona mesmo se o operador não estiver com esta sala aberta.)
    if (Array.isArray(messages)) {
      messages.forEach(msg => {
        if (msg.type === 3) {
          setChatClosed(true);
        }
      });
    }

    if (!selected.current && props.inProgressRooms && props.inProgressRooms.length) {
      handleSelectRoom(props.inProgressRooms[props.inProgressRooms.length - 1].client, props.inProgressRooms[props.inProgressRooms.length - 1]);
      selected.current = true;
    }

    if (props.inProgressRooms && props.inProgressRooms.length && JSON.stringify(inProgressRooms) !== JSON.stringify(props.inProgressRooms))
      setInProgressRooms(props.inProgressRooms);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    getRooms();
    if (inProgressRoomsLength === 0) {
      setSelectedRoom((prevEscPressed) => null);
    }

    // Verificar se props.inProgressRooms existe e é um array antes de iterar
    if (props.inProgressRooms && Array.isArray(props.inProgressRooms)) {
      props.inProgressRooms.forEach(room => {
        if (room && room.room_id) {
          roomRefs.current[room.room_id] = React.createRef();
        }
      });
    }

    // eslint-disable-next-line
  }, [props.inProgressRooms.length]);


  /* `clearSorting` saiu: era ele quem aplicava a BUSCA e, de quebra, apagava
     a ordenacao a cada poll -- o nome do metodo dizia isso. Agora busca e
     ordenacao sao passos de `filtrarConversas`. */


  /* `filterUnreadRooms` saiu para `temMensagemNaoLida()`, que conta QUALQUER
     mensagem do cliente nao lida -- a mesma conta do badge da linha, em vez
     de olhar so a ultima. */

  // So guarda o termo. Filtrar aqui era o ponto mais destrutivo da cadeia
  // antiga: `displayedRooms.filter(...)` gravado de volta em
  // `displayedRooms`.
  const handleSearch = termo => {
    setSearchValue(termo);
  };

  /* O efeito que chamava `clearSorting()` e depois refiltrava
     `displayedRooms` sobre si mesmo saiu inteiro: a derivacao do `useMemo`
     faz esse trabalho sem estado intermediario. */

  const handleSendingMessage = (text) => {
    setOperatorSendMessage(text);
  };

  const options = props.inProgressRooms && Array.isArray(props.inProgressRooms) 
    ? props.inProgressRooms.map(room => 
        room.client ? `${room.client.name || ''} ${room.client.code || ''}` : 'Sem informações'
      )
    : [];

  /**
   * Aplica a ordenacao e prepara a direcao do proximo clique.
   *
   * A sequencia visivel e a mesma de antes (1o clique ascendente, 2o
   * descendente) e a seta do SearchBar continua significando o que
   * significava. O que mudou: a ordenacao PERMANECE. Antes ela era aplicada
   * de forma imperativa e o poll seguinte a apagava, entao o botao nao
   * entregava o que promete.
   */
  const sortRooms = () => {
    setOrdemAplicada(sortOrder);
    setSortOrder(prev => prev === "asc" ? "desc" : "asc");
  };


  /**
   * Troca entre "Minhas conversas" e "Todas as conversas".
   *
   * Isto NAO e filtro de cliente: cada modo consulta um endpoint diferente,
   * e os dois caem no mesmo `inProgressRooms` do redux.
   *
   * O `null` vem do ToggleButtonGroup quando o operador clica no segmento JA
   * selecionado. Ignorar e o certo: sao dois modos exclusivos, e "nenhum dos
   * dois" nao e um estado que esta tela saiba desenhar.
   */
  const handleChange = (type) => {
    if (type === null || type === undefined) return;
    setFilterType(type)
    if (type === 'all') {
      getAllRooms();
    }
    else {
      getInProgressRooms(type);
    }
  };

  return (
    <Grid container wrap='nowrap' className={'row' + (props.openChat === true ? ' open-inprogress' : '')} sx={{ paddingRight: 0, paddingLeft: 0 }}>
      <Grid item xs sm={4} md={3} className={'inprogress-compact ' + (props.openChat === true ? 'open' : 'close')}
        sx={{
          paddingRight: 0, paddingLeft: 0,
          borderWidth: '0 5px 0 0',
          borderColor: theme.palette.secondary.main,
          borderStyle: 'solid'
        }} >
        {/* <Grid className='row'> */}
        <SearchBar
          options={props.inProgressRooms && Array.isArray(props.inProgressRooms) 
            ? props.inProgressRooms.map(room => room.client ? `${room.client.name || 'Sem Nome'} ${room.client.code || ''}` : 'Sem Informações')
            : []
          }
          onSearchChange={handleSearch}
          onSortRooms={sortRooms}
          sortOrder={sortOrder}
          clearSearch={() => handleSearch('')}
        />

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, pl: 0.5, pr: 1 }}>
          {/*
            Minhas / Todas as conversas. Era um Modal com dois botoes: tres
            passos (abrir, escolher, fechar) para uma escolha binaria.

            Segmentado, e nao dois icones soltos, porque os dois modos sao
            EXCLUSIVOS -- com icones soltos o unico sinal de qual esta ativo
            seria a cor, e numa barra estreita isso se perde. O segmento
            selecionado carrega essa leitura sozinho.
          */}
          {permissions?.includes('#change-profile') && user && (
            <ToggleButtonGroup
              exclusive
              size="small"
              value={filterType}
              onChange={(e, valor) => handleChange(valor)}
              aria-label="Conversas"
            >
              <ToggleButton value={user.id} aria-label="Minhas conversas" sx={{ px: 1, py: 0.4 }}>
                <Tooltip title='Minhas conversas' arrow>
                  <Person sx={{ fontSize: 18 }} />
                </Tooltip>
              </ToggleButton>
              <ToggleButton value="all" aria-label="Todas as conversas" sx={{ px: 1, py: 0.4 }}>
                <Tooltip title='Todas as conversas' arrow>
                  <Groups sx={{ fontSize: 18 }} />
                </Tooltip>
              </ToggleButton>
            </ToggleButtonGroup>
          )}
          <Tooltip title='Mensagens não lidas' arrow placement='right'>
            <IconButton style={{ color: theme.palette.text.primary }} onClick={() => setFilterUnread(!filterUnread)}>
              {filterUnread ? <InboxOutlined /> : <InboxSharp />}
            </IconButton>
          </Tooltip>
          {/*
            O filtro de canal (item 6). A linha da conversa ja mostra o icone do
            canal e o chip da marca desde 29/09 -- o que faltava era poder
            recortar por eles, em vez de varrer a lista com os olhos.
          */}
          <Select
            size="small"
            value={canal}
            onChange={(e) => setCanal(e.target.value)}
            inputProps={{ 'aria-label': 'Canal' }}
            SelectDisplayProps={{ 'data-testid': 'filtro-de-canal-do-chat' }}
            sx={{ flex: 1, minWidth: 0, fontSize: '0.8125rem' }}
          >
            {CANAIS.map((c) => (
              <MenuItem key={c.value} value={c.value} sx={{ fontSize: '0.8125rem' }}>{c.label}</MenuItem>
            ))}
          </Select>
        </Box>
        <RoomListTable
          rooms={conversasVisiveis}
          currentRoomId={props.currentRoomId}
          selectedRoom={roomId}
          handleSelectRoom={handleSelectRoom}
          setOpenChat={props.setOpenChat}
          setMessages={setMessages}
          inProgressRooms={inProgressRooms}
          messages={messages}
          roomRefs={roomRefs.current}
          operatorSendMessage={operatorSendMessage}
          whatsAppChats={whatsAppChats}
          /* Chegam em `Room` pelo `{...props}` do RoomListTable, e de la ao
             `useImperativeHandle` que o `selectedRoomRef` consulta. Sao
             estaveis, entao nao invalidam o `useMemo` das linhas. */
          setTotalDeMensagens={setTotalDeMensagens}
          enviarNaSalaSelecionada={enviarNaSalaSelecionada}
          avisarDigitacaoNaSalaSelecionada={avisarDigitacaoNaSalaSelecionada}
        />
        {/*
          O estado vazio desta lista, que NAO existia: operador sem conversa
          via um painel em branco e nenhuma palavra. (Havia um no bloco
          comentado que o RoomListTable substituiu, mas estava morto.)

          As duas mensagens dizem coisas diferentes, e e por isso que sao
          duas: "os filtros esconderam" manda o operador mexer no filtro, e
          seria mentira quando ele simplesmente nao tem atendimento aberto.
        */}
        {conversasVisiveis.length === 0 && (
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1, px: 2, py: 4, color: theme.palette.text.secondary }}>
            <InboxOutlined style={{ fontSize: 44, opacity: 0.55 }} />
            <Typography variant="body2" sx={{ textAlign: 'center' }}>
              {props.inProgressRooms?.length > 0
                ? 'Nenhuma conversa com os filtros atuais.'
                : 'Nenhuma conversa em atendimento.'}
            </Typography>
          </Box>
        )}
        {/* O bloco comentado que duplicava o RoomListTable saiu: ele lia
            `displayedRooms`, estado que deixou de existir. */}
      </Grid>
      <Grid item xs sm md className={'inprogress-chathead-compact ' + (props.openChat === true ? 'close' : 'open')} style={{ paddingRight: 0, paddingLeft: 0, maxHeight: '100vh', height: '100%' }}>
        <Grid className={`row`} style={{ maxHeight: props.selectedRoom ? 'auto' : 'auto', minHeight: '87%' }}>
          <Grid className='chat-head' sx={{ flexShrink: 0, height: props.selectedRoom ? 'auto' : '100vh' }}>
            {
              props.selectedRoom
                ?

                <ChatOptions
                  selectedRoom={props.selectedRoom}
                  setOpenChat={props.setOpenChat}
                  chatClosed={chatClosed}
                  setChatClosed={setChatClosed}
                  user={user}
                  roomRef={selectedRoomRef}
                  setInProgressRooms={setInProgressRooms}
                  inProgressRooms={inProgressRooms}
                  setRoomId={setRoomId}
                  setSelectedRoom={setSelectedRoom}
                  setMessages={setMessages}
                  dimension={props.dimensions.width}
                />
                :
                /*
                  O painel da direita quando não há conversa aberta.

                  Antes era o logotipo da SysFar com 351px de largura e
                  `alt=""` -- nenhuma palavra na tela e nada para quem usa
                  leitor de tela. Um painel desse tamanho em branco não diz
                  se o sistema está carregando, se deu erro, ou se é só não
                  ter atendimento no momento.

                  São TRÊS mensagens, pela mesma regra do estado vazio da
                  LISTA logo ao lado: cada uma leva a uma ação diferente, e
                  trocar uma pela outra seria mentira.

                  Com conversa na lista, o que falta é um clique. Com o
                  filtro escondendo tudo, há atendimento aberto e dizer
                  "nenhum atendimento aberto" mandaria o operador esperar por
                  algo que já chegou -- o que ele precisa é mexer no filtro.
                  Sem nenhuma conversa, não há o que clicar nem o que
                  filtrar, e aí o que informa é o que vai acontecer.
                */
                <Grid
                  container
                  direction="column"
                  justifyContent="center"
                  alignItems="center"
                  sx={{ height: '100%', gap: 1.5, px: 3, textAlign: 'center' }}
                >
                  <ForumOutlined sx={{ fontSize: 56, color: theme.palette.text.secondary, opacity: 0.45 }} />
                  <Typography variant="subtitle1" sx={{ fontWeight: 600, color: theme.palette.text.primary }}>
                    {conversasVisiveis.length > 0
                      ? 'Selecione uma conversa'
                      : props.inProgressRooms?.length > 0
                        ? 'Nada com os filtros atuais'
                        : 'Nenhum atendimento aberto'}
                  </Typography>
                  <Typography variant="body2" sx={{ color: theme.palette.text.secondary, maxWidth: 340 }}>
                    {conversasVisiveis.length > 0
                      ? 'Escolha um atendimento na lista ao lado para ver as mensagens e responder.'
                      : props.inProgressRooms?.length > 0
                        ? 'Há atendimentos abertos, mas nenhum passa pelos filtros da lista.'
                        : 'Quando um atendimento chegar para você, ele aparece na lista ao lado e a conversa abre aqui.'}
                  </Typography>
                </Grid>
            }
          </Grid>
          {props.selectedRoom ? selectedRoomRef.current && props.selectedRoom ? (
            <Chat
              roomId={roomId}
              selectedRoom={props.selectedRoom}
              setMessages={setMessages}
              messages={messages}
              setUnreadCount={selectedRoomRef.current?.setUnreadCount || (() => { })}
              unreadCount={selectedRoomRef.current?.getUnreadCount?.() || 0}
              messageReadFocus={selectedRoomRef.current?.messageReadFocus || (() => { })}
              sendMessage={selectedRoomRef.current?.sendMessage || (() => { })}
              readMessage={selectedRoomRef.current?.readMessage || (() => { })}
              sendFile={selectedRoomRef.current?.sendFile || (() => { })}
              totalDeMensagens={totalDeMensagens}
              carregarMaisAntigas={selectedRoomRef.current?.carregarMaisAntigas || (() => { })}
              inProgressRooms={props.inProgressRooms}
              handleSendingMessage={handleSendingMessage}
              setChatClosed={setChatClosed}
              chatClosed={chatClosed}
            />
          ) : (
            <Chat
              roomId={roomId}
              setMessages={setMessages}
              messages={messages}
              sendMessage={selectedRoomRef.current?.sendMessage || (() => { })}
              readMessage={selectedRoomRef.current?.readMessage || (() => { })}
              sendFile={selectedRoomRef.current?.sendFile || (() => { })}
              totalDeMensagens={totalDeMensagens}
              carregarMaisAntigas={selectedRoomRef.current?.carregarMaisAntigas || (() => { })}
              inProgressRooms={props.inProgressRooms}
              handleSendingMessage={handleSendingMessage}
            />
          ) : null}
        </Grid>
      </Grid>
    </Grid>
  )
}

const mapStateToProps = state => {
  const { rooms, clients, user, } = state;
  const { inProgressRooms, currentRoomId } = rooms;
  const { currentClient } = clients;
  const { users, permissions } = user;
  return { inProgressRooms, currentClient, users, currentRoomId, clients, permissions, rooms };
};

const mapDispatchToProps = dispatch => ({
  getInProgressRooms: operatorId => dispatch(getInProgressRooms(operatorId)),
  getClients: () => dispatch(getClients()),
  getClientById: clientId => dispatch(getClientById(clientId)),
  getUsers: () => dispatch(getUsers()),
  getUser: userId => dispatch(getUser(userId)),
  setCurrentClient: currentClient => dispatch(setCurrentClient(currentClient)),
  logOut: () => dispatch(logOut()),
  setCurrentUser: (token, user) => dispatch(setCurrentUser(token, user)),
  getAllRooms: () => dispatch(getAllRooms()),
  setCurrentChatMessages: messages => dispatch(setCurrentChatMessages(messages)),
  setViewedRooms: rooms => dispatch(setViewedRooms(rooms)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RoomList);